import React from "react";

import { Box } from "@mui/material";
import "../BrandMetadataReview.css";
import BrandReviewInstructions from "../UI/BrandReviewInstructions";
import ChildrenBrandsbyBrandTable from "../Reports/ChildrenBrandsbyBrandTable";

interface BrandMetadataReviewProps {
  brand_id: string;
}

const ReviewBrandChildren: React.FC<BrandMetadataReviewProps> = ({
  brand_id,
}) => {
  const user_instructions = {
    section_id: "brand-children",
    instruction_title: "Review Child Brands",
    purpose:
      "Ensure all child brands associated with the parent brand are accurately reflected in the metadata.",
    goal: "Ensure all countries where the brand operates are accurately reflected in the metadata.",
    task_description:
      "Validate the child brands in the `ownership_parent_id` attribute from the metadata. The table below displays the `Parent Brand ID`, `Child Brand ID`, and `Child Brand Name` to help validate the list of child brands associated with the selected parent brand.",
    task_steps: [
      {
        title: "Validate Child Brands",
        instructions: [
          "Review Existing Associations: Check the table to verify that all listed child brands (identified by `Child Brand ID` and `Child Brand Name`) are valid and accurately associated with the `Parent Brand ID`.",
          "Identify Missing or Incorrect Associations: Identify any child brands that should be added to the parent brand or brands that are incorrectly associated.",
        ],
      },
      {
        title: "Update Metadata",
        instructions: [
          "For corrections, navigate to the brand in `Kuebiko`.",
          "Select `Brand Edit`.",
          "Add Missing Child Brands: Set the `ownership_parent_id` for the child brand to the correct `Parent Brand ID`.",
          "Remove Incorrect Child Brands: Set the `ownership_parent_id` for the child brand to `null`.",
        ],
      },
    ],
  };

  return (
    <Box className="metadata-review-container">
      <BrandReviewInstructions {...user_instructions} />
      <ChildrenBrandsbyBrandTable brand_id={brand_id} custom_height="750px" />
    </Box>
  );
};

export default ReviewBrandChildren;
